import { Box, Heading } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import {
  createExamRequest,
  editExamRequest,
} from "../../../../modules/admin-modules/exams/Actions";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import {
  closeCreateExamDataModel,
  openQuestionsListModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getAllPaymentsRequest } from "../../../../modules/admin-modules/payment/Actions";
import { getAllTagsRequest } from "../../../../modules/admin-modules/tags/Actions";
import { getAllVideosRequest } from "../../../../modules/admin-modules/videos/Actions";
import { getLiveVideosRequest } from "../../../../modules/admin-modules/liveVideos/Actions";
import { getAllBucketsRequest } from "../../../../modules/superadmin-modules/bucket/Actions";
import StepOneForm from "../forms/step-one";

const AddExamData = ({ isAdd, data, setSelectedData, setExamData }) => {
  const [isFormOne, setFormOne] = useState(true);
  const [defaultData, setDefaultData] = useState({});
  const [errorslist, setErrorsList] = useState([]);

  const openExamData = useSelector((state) => state.model.isOpen15);
  const isLoading = useSelector((state) => state.chapters.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    if (openExamData) {
      dispatch(getAllChaptersRequest());
      dispatch(getAllVideosRequest());
      dispatch(getLiveVideosRequest());
      dispatch(getAllPaymentsRequest());
      dispatch(getAllBucketsRequest());
      dispatch(getAllGroupsRequest());
      dispatch(getAllTagsRequest());
    }
  }, [openExamData]);

  const mapExamToForm = (exam) => {
    if (!exam?.id) return {};

    return {
      id: exam.id,
      name: exam.name,
      type:
        exam.hw_flag == 1 && String(exam.type) === "7"
          ? "7_hw"
          : String(exam.type ?? ""),
      hw_flag: exam.hw_flag == 1 ? 1 : 0,
      sub_type: String(exam.sub_type ?? ""),
      question_number: exam.question_number,
      is_timed: exam.is_timed,
      time: exam.time,
      published: exam.published,
      enable: exam.enable,
      redo_flag: exam.redo_flag,
      random: String(exam.random ?? ""),
      bookmark: String(exam.bookmark ?? ""),
      auto_publish_result: exam.auto_publish_result,
      difficulty: String(exam.difficulty ?? ""),
      success_score: exam.success_score,
      chapter_id: exam.chapter?.id,
      payment_subject_id: exam.payment_subject?.id,
      video_id: exam.video?.id ?? null,
      live_video_id: exam.live_video?.id ?? exam.live_video_id ?? null,
      video_source:
        exam.live_video?.id || exam.live_video_id ? "live_video" : "video",
      student_group_ids: exam.student_groups?.map((group) => group.id) || [],
      buckets:
        exam.exam_buckets?.map((bucket) => ({
          id: bucket.id,
          bucket_id: bucket.id,
          no_of_questions: bucket.pivot?.no_of_questions,
          type: bucket.pivot?.type ?? 0,
          name: bucket.name,
        })) || [],
      tags: (exam.tags || exam.exam_tags)?.map((tag) => ({
        id: tag.id,
        tag_id: tag.id,
        no_of_questions: tag.pivot?.no_of_questions,
        name: tag.name,
      })) || [],
      // Keep nested objects for Select defaultValue UI
      chapter: exam.chapter,
      payment_subject: exam.payment_subject,
      student_groups: exam.student_groups,
      exam_buckets: exam.exam_buckets,
      exam_tags: exam.tags || exam.exam_tags,
      video: exam.video,
      live_video: exam.live_video,
    };
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: defaultData,
    shouldUnregister: true,
  });

  useEffect(() => {
    if (isAdd) {
      const defaults = {
        time: 0,
        is_timed: 0,
        auto_publish_result: 1,
        published: 1,
        enable: 1,
        redo_flag: 1,
        difficulty: "1",
        bookmark: "0",
        type: "1",
      };
      setDefaultData(defaults);
      reset(defaults);
      return;
    }

    if (data?.id) {
      const mapped = mapExamToForm(data);
      setDefaultData(mapped);
      reset(mapped);
    }
  }, [data, isAdd, reset]);

  const watchSubType = watch("sub_type") || defaultData?.sub_type || data?.sub_type;
  const watchTotalQustions =
    watch("question_number") ||
    defaultData?.question_number ||
    data?.question_number;
  const watchBucket =
    watch("buckets") || defaultData?.buckets || data?.exam_buckets;
  const watchTags =
    watch("tags") || defaultData?.tags || data?.tags || data?.exam_tags;
  const watchTimer = watch("is_timed");
  const watchQuestionWay =
    watch("random") || defaultData?.random || data?.random;
  const watchType = watch("type") || defaultData?.type || data?.type;
  const watchVideoSource =
    watch("video_source") || defaultData?.video_source || "video";

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة اختبار" : "تعديل  اختبار"}
      </Heading>
    </Box>
  );

  const onSubmit = async (values) => {
    setErrorsList([]);
    const totel = {
      ...defaultData,
      ...values,
      chapter_id: values?.chapter_id || defaultData?.chapter_id || data?.chapter?.id,
      payment_subject_id:
        values?.payment_subject_id ||
        defaultData?.payment_subject_id ||
        data?.payment_subject?.id,
      student_group_ids:
        values?.student_group_ids ||
        defaultData?.student_group_ids ||
        data?.student_groups?.map((group) => group.id),
      buckets: values?.buckets || defaultData?.buckets,
      tags: values?.tags || defaultData?.tags,
    };

    totel.hw_flag = totel.type == "7_hw" ? 1 : 0;
    if (totel.type == "7_hw") totel.type = "7";

    if (totel.type != "6") {
      delete totel.video_id;
      delete totel.live_video_id;
    } else if (totel.video_source === "live_video") {
      delete totel.video_id;
    } else {
      delete totel.live_video_id;
    }

    const requiredKeys = [
      "difficulty",
      "bookmark",
      "type",
      "chapter_id",
      "random",
      "sub_type",
    ];

    // Add conditional required keys based on sub_type
    if (totel.sub_type == "2") {
      requiredKeys.push("buckets");
    } else if (totel.sub_type == "3") {
      requiredKeys.push("tags");
    }

    requiredKeys?.map((val) => {
      if (!Object.keys(totel).includes(val)) {
        setErrorsList((prev) => [...prev, val]);
      }
    });
    const keys = [
      "created_at",
      "updated_at",
      "course",
      "teacher",
      "edit",
      "delete",
      "Action",
      "Actions",
      "payment_subject",
      "exam_buckets",
      "exam_tags",
      "video",
      "live_video",
      "video_source",
      "chapter",
      "student_groups",
      "id",
    ];

    let formData = new FormData();
    let chapters = [];
    for (let key in totel) {
      if (key == "buckets") {
        totel[key]
          ?.filter((val) => val != undefined)
          ?.map((val, idx) => {
            if (val) {
              chapters.push(val);
              formData.append(
                `buckets[${idx}][bucket_id]`,
                val.id ? val.id : val?.bucket_id
              );
              formData.append(
                `buckets[${idx}][no_of_questions]`,
                val.no_of_questions
                  ? val.no_of_questions
                  : totel?.question_number
              );
              formData.append(
                `buckets[${idx}][type]`,
                val.type !== undefined && val.type !== null ? val.type : 0
              );
            }
          });
      } else if (key == "tags") {
        totel[key]
          ?.filter((val) => val != undefined)
          ?.map((val, idx) => {
            if (val) {
              formData.append(
                `tags[${idx}][tag_id]`,
                val.id ? val.id : val?.tag_id
              );
              formData.append(
                `tags[${idx}][no_of_questions]`,
                val.no_of_questions
                  ? val.no_of_questions
                  : totel?.question_number
              );
            }
          });
      } else if (key == "student_group_ids") {
        (totel?.student_group_ids || [])
          ?.map((val, index) => {
            formData.append(`student_group_ids[${index}]`, val);
          });
      } else if (!keys.includes(key)) {
        if (totel[key] == true) formData.append(key, "1");
        else if (totel[key] == false) formData.append(key, "0");
        else if (totel[key] != null) formData.append(key, totel[key]);
      }
    }
    if (totel["time"] == 0) {
      formData.append("is_timed", 0);
      formData.append("time", 0);
    }
    const action = (data) => {
      dispatch(closeCreateExamDataModel());
      setSelectedData({});
      reset();
      setFormOne(true);

      setExamData?.({
        chapter_id: chapters?.[0]?.chapter_id || chapters?.[0]?.bucket_id,
        exam: data?.id,
        question_number: data?.question_number,
      });
      isAdd && watchQuestionWay == 0 && dispatch(openQuestionsListModel());
    };

    if (errorslist?.length == 0) {
      if (isAdd) {
        dispatch(createExamRequest(formData, action));
      } else {
        formData.append("_method", "PUT");

        dispatch(
          editExamRequest({
            id: data?.id,
            formData: formData,
            action: action,
          })
        );
      }
    }
  };

  useEffect(() => {
    if (watchTimer == 0 || watchTimer === false) setValue("time", 0);
  }, [watchTimer, setValue]);

  const closeFunc = () => {
    dispatch(closeCreateExamDataModel());
    setSelectedData({});
    reset();
    setFormOne(true);
  };

  useEffect(() => {
    if (watchQuestionWay == 0 || watchQuestionWay === "0") {
      setValue("sub_type", "1");
    }
  }, [watchQuestionWay, setValue]);

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openExamData}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <StepOneForm
          key={isAdd ? "add-exam" : `edit-exam-${defaultData?.id || data?.id}`}
          data={isAdd ? defaultData : defaultData?.id ? defaultData : data}
          register={register}
          watchTimer={watchTimer}
          errors={errors}
          isFormOne={isFormOne}
          watchType={watchType}
          setValue={setValue}
          watchSubType={watchSubType}
          watchTotalQustions={watchTotalQustions}
          watchQuestionWay={watchQuestionWay}
          watchBucket={watchBucket}
          watchTags={watchTags}
          watchVideoSource={watchVideoSource}
          errorslist={errorslist}
        />
      </form>
    </MainModel>
  );
};

export default AddExamData;
